import {LovValueSummary} from '../../../../../common/lov/lov-value/api/model/lovValueSummary.model';
import {DtoModel} from '../../../../../common/entity/dto/dto.model';
import {
    FormDefinitionFieldSubType,
    FormDefinitionFieldSummaryModel,
    FormDefinitionFieldType
} from './formDefinitionFieldSummary.model';
import {FormFieldDefinitionOptionModel} from './formFieldDefinitionOption.model';

export class FormDefinitionFieldModel implements DtoModel {
    summary: FormDefinitionFieldSummaryModel;
    required: boolean;
    decimalDigits: number;
    options: FormFieldDefinitionOptionModel[] = [];
    data: string;
    defaultValue: any;
    unit: string;
    notMeasuredAvailable: boolean;
}
